import http from "../../http-common";

const getAll = async () => {
  return await http
    .get("/admin/concession-request")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getCount = async () => {
  return await http
    .get("/admin/concession-request/count")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getById = async (id) => {
  return await http
    .get(`/admin/concession-request/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getResume = async (data) => {
  return await http
    .get("/admin/concession-request/resume", data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const resolveRequest = async (id, data) => {
  return await http
    .post(`/admin/concession-request/${id}`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getAll,
  getById,
  getCount,
  getResume,
  resolveRequest,
};
